import { render, staticRenderFns } from "./ApprovalManagement.vue?vue&type=template&id=3e99f802&scoped=true"
import script from "./ApprovalManagement.vue?vue&type=script&lang=js"
export * from "./ApprovalManagement.vue?vue&type=script&lang=js"
import style0 from "./ApprovalManagement.vue?vue&type=style&index=0&id=3e99f802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e99f802",
  null
  
)

export default component.exports